import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollTop = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0); // Scrolls to the top of the page
    }, [pathname]); // Runs whenever the route (pathname) changes

    return null; // This component doesn't render anything
};

export default ScrollTop;
